import SlsTipoPedidoClient from '@/api/SistemaDKP/sls-tipo-pedido.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSTipoPedidoService {
  constructor() {
    this.client = new SlsTipoPedidoClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os tipo pedido');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Tipo Pedido');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Tipo Pedido');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.client.update(id, data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Tipo Pedido');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Tipo Pedido');
    }
  }

  async getPerfis(id) {
    try {
      const data = await this.client.getPerfis(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar os perfis do Tipo de Pedido');
      return { data: [] };
    }
  }

  async setPerfis(id, perfis) {
    try {
      const data = await this.client.setPerfis(id, perfis);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao salvar os perfis do Tipo de Pedido');
      return null;
    }
  }
}
